import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { HealthState } from '../../models/health.model';
import * as HealthActions from '../actions/health.actions';

export const initialState: HealthState = {
  somaticCellCountCows: null,
  healthSummary: null,
  healthYearSummary: null,
};

export const healthReducer = createReducer<HealthState>(
  initialState,
  on(HealthActions.loadSomaticCellCountAttentionsSuccess, (state, { somaticCellCountCows }) => ({
    ...state,
    somaticCellCountCows,
  })),
  on(HealthActions.loadHealthSummarySuccess, (state, { healthSummary }) => ({
    ...state,
    healthSummary,
  })),
  on(HealthActions.loadHealthYearSummarySuccess, (state, { healthYearSummary }) => ({
    ...state,
    healthYearSummary,
  })),
  on(UserActions.relationshipSelected, () => initialState),
);
